import { connect } from 'react-redux';
import { setDrawerDirty } from 'redux-core/dialogs/actions';

const mapDispatchToProps = { setDrawerDirty };

export default connect(undefined, mapDispatchToProps);
